module.exports = __webpack_public_path__ + "static/media/seo.00c0661e.svg";